<template>
	<div style="margin-top: 100px">
		<div style="background: red">
			red
			<portal to="destination">
				Content will be dynamically sent to the destination that `name` evaluates to
			</portal>
			<portal target-el="#place-on-the-page">
				Content will be dynamically sent to the destination that `name` evaluates to
			</portal>
		</div>
		<div style="background: green">
			green
			<portal-target v-bind:name="name">
				by changing the 'name', you can define which portal's content should be shown.
			</portal-target>
		</div>

	</div>
</template>

<script>
import {
	Portal,
	PortalTarget,
	// MountingPortal
} from 'portal-vue';

export default {
	name: "TestPage",

	components: {
		Portal,
		PortalTarget,
		// MountingPortal,
	},
	data: () => ({
		show1: true,
		show2: true,
	}),
};
</script>

<style scoped>

</style>
